module.exports = __webpack_public_path__ + "static/media/html.5813feb8.png";